import React from 'react';
import { Button, Icon } from 'ui';

const RSVPButtons = ({ pastEvent, setUserAttendance, statusLoading }) => {
  const AttendanceButton = ({ children, value }) => (
    <Button
      className="EventRegistration-AttendanceButton"
      disabled={statusLoading !== null && statusLoading !== value}
      loading={statusLoading !== null && statusLoading === value}
      onClick={() => setUserAttendance(value)}
    >
      <Icon name={value ? 'correct' : 'incorrect'} />
      {children}
    </Button>
  );
  return (
    <>
      <AttendanceButton value={true}>
        {pastEvent
          ? t('in_person_training.rsvp_status.did_attend')
          : t('in_person_training.rsvp_status.will_attend')}
      </AttendanceButton>
      <AttendanceButton value={false}>
        {pastEvent
          ? t('in_person_training.rsvp_status.did_not_attend')
          : t('in_person_training.rsvp_status.will_not_attend')}
      </AttendanceButton>
    </>
  );
};

export default RSVPButtons;
